

export const index = 0;
export const component = async () => (await import('../entries/pages/_layout.svelte.js')).default;
export const file = '_app/immutable/components/pages/_layout.svelte-534c3049.js';
export const imports = ["_app/immutable/components/pages/_layout.svelte-534c3049.js","_app/immutable/chunks/index-d33e9054.js"];
export const stylesheets = ["_app/immutable/assets/_layout-007419ef.css"];
